import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../service/api";
import { CustomModal } from "../../../components/CustomModal";
import { MDBBtn, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import { LoadingSpinner } from "../../../components/LoadingSpinner";
import { TextInput } from "../../../components/core/inputs/TextInput";

export interface AddUserModalProps {
    open: boolean;
    groupId: number;
    onClose: () => void;
    onConfirm: (id: number, rightsId: number) => void;
}
export const AddUserModal = ({open, groupId, onClose, onConfirm}: AddUserModalProps) => {
    const [selectedUserId, setSelectedUserId] = useState<number|null>(null);
    const [selectedPermissionId, setSelectedPermissionId] = useState<number|null>(null);
    const [users, setUsers] = useState<any[]|null>(null);
    const [permissions, setPermissions] = useState<any[]|null>(null);
    const [search, setSearch] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        if (!open) return;
        setSearch('');
        setSelectedUserId(null);
        setSelectedPermissionId(null);
        setUsers(null);

        API.GET(`/api/admgroups/${groupId}/notu`)
            .then(u => setUsers(u))
            .catch(err => alert(err.message));
        API.GET('/api/rights')
            .then(r => setPermissions(r.rights))
            .catch(err => alert(err.message));
    }, [open]);

    return (
        <CustomModal
            open={open}
            onClose={onClose}
            title={t('add_user_to_group')}
            footer={<>
                <MDBBtn color="secondary" onClick={onClose}>{t('cancel')}</MDBBtn>
                <MDBBtn color="primary" disabled={selectedUserId == null || selectedPermissionId == null} onClick={() => onConfirm(selectedUserId ?? -1, selectedPermissionId ?? -1)}>{t('confirm')}</MDBBtn>
            </>}
        >
            {(users == null || permissions == null) && <LoadingSpinner/>}
            {(users !== null && permissions !== null) && <>
                <div className="d-flex flex-column">
                    <TextInput label={t('search')} value={search} onValueChange={setSearch}/>

                    <div className="d-flex flex-column overflow-auto px-1 pt-2 pb-2" style={{maxHeight: 500, minWidth: 300, userSelect: 'none'}}>
                        {users.map(u => (
                            <div
                                key={u.id}
                                className={"flex-row align-items-center hover-shadow p-1 "+(u.pending?' list-group-item-warning fst-italic':'')}
                                style={{cursor: 'pointer', background: u.id == selectedUserId ? '#0000001a' :'', display: u.Name.toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) == '-1' ? 'none': 'flex'}}
                                onClick={() => { setSearch(''); setSelectedUserId(u.id); }}
                            >
                                <MDBIcon icon="user" color="primary"/>
                                {u.pending && <MDBIcon icon="fas fa-hourglass" color="primary" className="ms-1"/>}
                                <span className="ms-1">{u.Name}</span>
                            </div>
                        ))}
                    </div>

                    <span className="w-100 text-center"><h6>{t('permissions')}</h6></span>

                    <div className="d-flex flex-column overflow-auto px-1 pt-2 pb-2" style={{maxHeight: 500, minWidth: 300, userSelect: 'none'}}>
                        {permissions.map(p => (
                            <div key={p.id} className="flex-row align-items-center hover-shadow p-1" style={{cursor: 'pointer', background: p.id == selectedPermissionId ? '#0000001a' :'', display: p.Name.toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) == '-1' ? 'none': 'flex'}} onClick={() => setSelectedPermissionId(p.id)}>
                                <MDBIcon icon="fas fa-briefcase" color="primary"/>
                                <span className="ms-1">{p.Name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </>}
        </CustomModal>
    )
}